import {postMethod} from '~/api'

async function post(body) {
    return await postMethod('/api/addReviewFromEmail', body)
}

export {post}
